// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js","970":"component---src-pages-using-typescript-tsx"}[chunkId] || chunkId) + "-" + {"678":"4202a2e7e7ac605fe422","731":"d8bed635144c4115c634","843":"a75101acca522f1da784","883":"535b32425a621f602ae6","970":"d0acc4f5e8bd16923278"}[chunkId] + ".js";
};